import { devMode } from "@utilities/helpers";
import appConfig from "../app.config.json";
import builderConfig from "../builder.config.json";
export const settings = devMode
    ? { ...appConfig, ...builderConfig, targetRoute: "/" }
    : { ...appConfig, ...builderConfig };
